<template>
  <b-select
    :placeholder="$t(placeholder)"
    @input="selectionChanged"
    icon="domain"
    v-model="selectedCountry"
  >
    <option
      v-for="country in sortedCountries"
      :key="country.id"
      :value="country.id"
      >{{ $t(country.id) }}</option
    >
  </b-select>
</template>

<script>
import Countries from '@/constants/countries.js'
export default {
  components: {},
  props: {
    value: String,
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedCountry: null,
      countries: Countries
    }
  },
  watch: {
    value: function(val) {
      this.selectedCountry = val
    }
  },
  methods: {
    selectionChanged: function(val) {
      this.$emit('input', val)
    }
  },
  computed: {
    sortedCountries: function() {
      return this.$_.sortBy(this.countries, 'name')
    }
  }
}
</script>
